if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.variantIdInput = this.form.querySelector('[name=id]');
      if (this.dataset.ffExplicitSize !== 'true') this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.onExplicitSizeState = (event) => {
        if (event.target === this.getExplicitSizePicker()) this.syncExplicitSizeState();
      };
      this.onExplicitPaymentClick = (event) => {
        if (this.isExplicitSizeForm() && event.target.closest('.product-form__checkout') && !this.canBuyExplicitSize()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.syncExplicitSizeState();
        }
      };
    }

    connectedCallback() {
      document.addEventListener('ff:size-state', this.onExplicitSizeState);
      this.addEventListener('click', this.onExplicitPaymentClick, true);
      this.syncExplicitSizeState();
    }

    disconnectedCallback() {
      document.removeEventListener('ff:size-state', this.onExplicitSizeState);
      this.removeEventListener('click', this.onExplicitPaymentClick, true);
    }

    getExplicitSizePicker() {
      const root = this.closest('floated-form, quick-add-modal, [id^="ProductInfo-"]') || this.closest('.shopify-section') || this.parentElement;
      return Array.from(root.querySelectorAll('[data-ff-explicit-size="true"]'))
        .find((picker) => picker.matches('variant-radios, variant-selects') && picker.dataset.productFormId === this.form.getAttribute('id'));
    }

    getExplicitSizeState() {
      return this.getExplicitSizePicker()?.ffExplicitState;
    }

    isExplicitSizeForm() {
      return this.dataset.ffExplicitSize === 'true' || Boolean(this.getExplicitSizePicker());
    }

    canBuyExplicitSize() {
      const state = this.getExplicitSizeState();
      return Boolean(state && state.state === 'available' && state.buyable && state.variant?.available &&
        String(state.variant.id) === String(state.variantId) && state.options?.length === state.variant.options?.length &&
        state.options.every((value, index) => value != null && value === state.variant.options[index]));
    }

    getExplicitSizeMessage() {
      const picker = this.getExplicitSizePicker();
      if (picker?.getExplicitSizeMessage) return picker.getExplicitSizeMessage();
      const state = this.getExplicitSizeState();
      if (state?.state === 'soldout') return 'Diese Größe ist aktuell ausverkauft';
      if (state?.state === 'unavailable') return 'Diese Kombination wird nicht angeboten';
      if (state?.state === 'partial' && state.missing?.length) return `Bitte ${state.missing.join(' und ')} wählen`;
      return 'Bitte Weite und Länge wählen';
    }

    syncExplicitSizeState() {
      if (!this.isExplicitSizeForm()) return;
      const selectionKey = JSON.stringify(this.getExplicitSizeState()?.options || []);
      if (this.ffLastSelectionKey !== undefined && selectionKey !== this.ffLastSelectionKey) {
        this.error = false;
        this.handleErrorMessage();
        this.submitButton.querySelector('.sold-out-message')?.classList.add('hidden');
        this.submitButton.querySelector('span')?.classList.remove('hidden');
      }
      this.ffLastSelectionKey = selectionKey;
      const buyable = this.canBuyExplicitSize();
      this.variantIdInput.value = buyable ? this.getExplicitSizeState().variantId : '';
      this.variantIdInput.disabled = !buyable;
      this.submitButton.disabled = !buyable || Boolean(this.ffSubmitting);
      if (!buyable || this.ffSubmitting) this.submitButton.setAttribute('aria-disabled', 'true');
      else if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      const label = this.submitButton.querySelector('span');
      if (label) label.textContent = buyable ? (window.variantStrings?.addToCart || 'In den Warenkorb') : this.getExplicitSizeMessage();
      this.querySelectorAll('.product-form__checkout').forEach((checkout) => {
        checkout.hidden = !buyable;
        checkout.inert = !buyable;
        checkout.style.display = buyable ? '' : 'none';
      });
    }

    validateExplicitSizePurchase() {
      if (!this.isExplicitSizeForm()) return true;
      const valid = this.canBuyExplicitSize() && !this.variantIdInput.disabled &&
        this.variantIdInput.value === String(this.getExplicitSizeState().variantId);
      if (!valid) {
        this.syncExplicitSizeState();
        this.handleErrorMessage(this.getExplicitSizeMessage());
      }
      return valid;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.validateExplicitSizePurchase()) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.ffSubmitting = this.isExplicitSizeForm();
      const explicitSizePicker = this.getExplicitSizePicker();
      if (explicitSizePicker) explicitSizePicker.ffSubmitting = true;
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );
            // -------------------------------------------
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            if (explicitSizePicker && (String(this.getExplicitSizeState()?.variantId) !== String(formData.get('id')) || !this.canBuyExplicitSize())) {
              this.error = false;
              this.handleErrorMessage();
              return;
            }
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

           // VARIANT ADDED EVENT
           document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );
          // -------------------------------------------

          fetch(`${routes.cart_url}.js`)
						.then((response) => {
							return response.text()
						})
						.then((state) => {
							const parsedState = JSON.parse(state)

							// dispatch cart:change for the entire basket
							document.dispatchEvent(
								new CustomEvent('cart:change', {
									detail: {
										cart: parsedState,
										sectionId: this.dataset.source,
									},
								})
							)
							// dispatch cart:change for the entire basket

						})
						.catch((error) => {
							console.error('Error fetching cart state:', error);
						})

          if (!this.error){
             publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
               productVariantId: formData.get('id')
              });
            }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.ffSubmitting = false;
          if (explicitSizePicker) explicitSizePicker.ffSubmitting = false;
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.syncExplicitSizeState();
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
